import { NavLink } from "react-router-dom"
import { LayoutDashboard, Users, Building2, Star, Shield, LayoutGrid, TrendingUp, LogOut, ShoppingCart, Headphones, HelpCircle, Tag, CreditCard, Package, Wallet, RotateCcw, Settings, UserCircle, DollarSign, Award } from "lucide-react"
import { useDispatch, useSelector } from "react-redux"
import { clearCredentials } from "../features/auth/authSlice"
import type { RootState, AppDispatch } from "../app/store"

const links = [
  { to: "/", icon: LayoutDashboard, label: "Overview" },
  { to: "/users", icon: Users, label: "Users" },
  { to: "/businesses", icon: Building2, label: "Businesses" },
  { to: "/products", icon: Package, label: "Products" },
  { to: "/payments", icon: CreditCard, label: "Payments" },
  { to: "/wallets", icon: Wallet, label: "Wallets" },
  { to: "/commission", icon: DollarSign, label: "Commission" },
  { to: "/early-adopters", icon: Award, label: "Early Adopters" },
  { to: "/returns", icon: RotateCcw, label: "Returns" },
  { to: "/reviews", icon: Star, label: "Reviews" },
  { to: "/orders", icon: ShoppingCart, label: "Orders" },
  { to: "/tickets", icon: Headphones, label: "Support Tickets" },
  { to: "/faqs", icon: HelpCircle, label: "FAQs" },
  { to: "/coupons", icon: Tag, label: "Coupons" },
  { to: "/subscriptions", icon: CreditCard, label: "Subscriptions" },
  { to: "/roles", icon: Shield, label: "Roles" },
  { to: "/categories", icon: LayoutGrid, label: "Categories & Types" },
  { to: "/search-insights", icon: TrendingUp, label: "Search Insights" },
  { to: "/settings", icon: Settings, label: "Settings" },
]

export default function Sidebar() {
  const dispatch = useDispatch<AppDispatch>()
  const user = useSelector((s: RootState) => s.auth.user)

  return (
    <aside className="w-64 min-h-screen bg-gray-900 text-white flex flex-col">
      <div className="p-6 border-b border-gray-700">
        <h1 className="text-xl font-bold text-white">NLinks Admin</h1>
        <p className="text-xs text-gray-400 mt-1 truncate">{user?.email}</p>
      </div>

      <nav className="flex-1 p-4 space-y-1">
        {links.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                isActive ? "bg-blue-600 text-white" : "text-gray-300 hover:bg-gray-800 hover:text-white"
              }`
            }
          >
            <Icon size={18} />
            {label}
          </NavLink>
        ))}
      </nav>

      <div className="p-4 border-t border-gray-700 space-y-1">
        <NavLink
          to="/profile"
          className={({ isActive }) =>
            `flex items-center gap-3 px-3 py-2.5 w-full rounded-lg text-sm font-medium transition-colors ${
              isActive ? "bg-blue-600 text-white" : "text-gray-300 hover:bg-gray-800 hover:text-white"
            }`
          }
        >
          <UserCircle size={18} />
          Profile
        </NavLink>
        <button
          onClick={() => dispatch(clearCredentials())}
          className="flex items-center gap-3 px-3 py-2.5 w-full rounded-lg text-sm font-medium text-gray-300 hover:bg-gray-800 hover:text-white transition-colors"
        >
          <LogOut size={18} />
          Sign Out
        </button>
      </div>
    </aside>
  )
}
